import { MaintenanceContext } from "@/contexts/maintenanceContext";
import { useMaintenanceStatus } from "@/hooks/useMaintenanceStatus";
import type { ReactNode } from "react";

interface MaintenanceProviderProps {
  children: ReactNode;
}

export const MaintenanceProvider = ({ children }: MaintenanceProviderProps) => {
  const { data, isLoading } = useMaintenanceStatus();

  const value = {
    isMaintenanceMode: data?.isMaintenanceMode ?? false,
    maintenanceMessage: data?.maintenanceMessage ?? null,
    isLoading,
  };

  return <MaintenanceContext.Provider value={value}>{children}</MaintenanceContext.Provider>;
};
